import React, { useState, Fragment, useEffect } from "react";
import BreadCrumb from "../../layout/Breadcrumb";
import {
  Container,
  Row,
  Col,
  Badge,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  Label,
  Media,
  Card,
  CardBody,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  TabContent,
} from "reactstrap";
import ScrollArea from "react-scrollbar";
import SuppliesLogo from "../../assets/images/B2BSuppliesLogo.jpg";
import axios from "axios";

const Buscador = (props) => {
  const segmentos = require("../../data/UNSPC_segmento.json");
  const familias = require("../../data/UNSPC_familias.json");
  const clases = require("../../data/UNSPC_class.json");

  const [ActiveTab, setActiveTab] = useState("1");
  const [filterType, setFilterType] = useState("PRODUCTOS");
  const [filteredSegmentos, setFilteredSegmentos] = useState([]);
  useEffect(() => {
    filterSegmento("PRODUCTOS");
  }, []);

  const filterSegmento = (type) => {
    setFilterType(type);
    if (type == "PRODUCTOS") {
      setFilteredSegmentos(
        segmentos.filter((item) => !item.esp.includes("SERVICIOS"))
      );
    } else {
      setFilteredSegmentos(
        segmentos.filter((item) => item.esp.includes("SERVICIOS"))
      );
    }
  };

  const [currentSegmento, setCurrentSegmento] = useState(null);
  const [currentFamilia, setCurrentFamilia] = useState(null);

  const [subFamilias, setSubFamilias] = useState([]);
  const [subClases, setSubClases] = useState([]);

  const [selectedClases, setSelectedClases] = useState([]);

  const setSegmento = (i, code) => {
    setCurrentSegmento(i);
    if (i == currentSegmento) {
      setCurrentSegmento(null);
    }
    setSubFamilias(
      familias.filter(
        (familia) =>
          familia.code.toString().substring(0, 2) ==
          code.toString().substring(0, 2)
      )
    );
    setCurrentFamilia(null);
  };

  const selectFamilia = (a, category) => {
    setCurrentFamilia(a);
    if (a == currentFamilia) {
      setCurrentFamilia(null);
    }
    setSubClases(
      clases.filter(
        (clase) =>
          clase.code.toString().substring(0, 4) ==
          category.code.toString().substring(0, 4)
      )
    );
  };

  const selectClase = (category) => {
    if (selectedClases.indexOf(category) == -1) {
      setSelectedClases((clases) => [...clases, category]);
    } else {
      console.log("Category already selected", selectedClases);
    }
  };

  const deleteClase = (clase) => {
    if (selectedClases.indexOf(clase) != -1) {
      setSelectedClases(selectedClases.filter((clas) => clas != clase));
    }
  };

  const [keyWord, setKeyWord] = useState("");
  const [serachedItems, setSearchedItems] = useState([]);
  const searchKeyWord = () => {
    if (keyWord != "") {
      let itemsMatched = clases.filter((item) =>
        item.esp.toLowerCase().includes(keyWord)
      );
      setSearchedItems(itemsMatched);
    } else {
      setSearchedItems([]);
    }
  };

  const returnedItems = () => {};
  const prestashopAPI = {
    URL: "https://b2bsupplies.net/en/module/b2bsuppliers/B2bApi?",
    token: "OCLTZXD8TIL0NI059XHV8Y39YWYYDWVX",
    type: {
      products: "Products-Array-UNSPC",
      suppliers: "Suppliers-Array-UNSPC",
    },
  };

  const [products, setProducts] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const searchForItems = async () => {
    let items = selectedClases;
    items.push({ code: "" });

    const UNSPCsString = `${items
      .reduce((acc, el) => {
        return acc.concat(el.code);
      }, [])
      .map((el) => {
        return `${el}`;
      })}`;

    // LLAMADA A API DE PRESTASHOP
    await axios
      .get(
        `${prestashopAPI.URL}token=${prestashopAPI.token}&type=${
          prestashopAPI.type.products
        }&q=${UNSPCsString.replaceAll(",", "|")}
       `
      )
      .then((res) => {
        let resData = res.data;
        let products = resData.reduce((acc,el)=>{return acc.concat({...el,description:el.description?el.description.replace("class","className"):""}) },[])
        products = products.reduce((acc,el)=>{return acc.concat({...el, description:{__html:el.description} })},[])
        setProducts(products);
      });

    await axios
      .get(
        `${prestashopAPI.URL}token=${prestashopAPI.token}&type=${
          prestashopAPI.type.suppliers
        }&q=${UNSPCsString.replaceAll(",", "|")}
       `
      )
      .then((res) => {
        let resData = res.data;
        let suppliers = resData.reduce((acc,el)=>{return acc.concat({...el,description:el.description?el.description.replace("class","className"):""}) },[])
        suppliers = suppliers.reduce((acc,el)=>{return acc.concat({...el, description:{__html:el.description} })},[])
        setSuppliers(suppliers);
      });
  };

  return (
    <Fragment>
      <Container>
        <Row>
          <Col sm="12" className="width-50">
            <Media
              className="center-horizontal m-b-50"
              style={{ width: "450px" }}
              src={SuppliesLogo}
            />

            <InputGroup>
              <Input
                type="text"
                className="form-control m-t-5 m-b-5"
                placeholder={`BUSQUEDA DE ${filterType}`}
                value={keyWord}
                disabled={serachedItems.length == 0 ? false : true}
                onChange={(event) =>
                  setKeyWord(event.target.value.toLowerCase())
                }
              />
              <InputGroupAddon addonType="append">
                <InputGroupText>
                  {serachedItems.length == 0 ? (
                    <Button color="primary" onClick={searchKeyWord}>
                      {"Buscar"}
                    </Button>
                  ) : (
                    <Button
                      color="light"
                      onClick={() => {
                        setKeyWord("");
                        setSearchedItems([]);
                        setProducts([]);
                      }}
                    >
                      {"Limpiar"}
                    </Button>
                  )}
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>

            <div className={`display-flex`}>
              <div>
                <FormGroup className="m-t-5 m-checkbox-inline mb-0 custom-radio-ml">
                  <div className="radio radio-primary">
                    <Input
                      id="radioinline1"
                      type="radio"
                      name="radio1"
                      value="option1"
                      defaultChecked
                      onClick={() => filterSegmento("PRODUCTOS")}
                    />
                    <Label className="mb-0" for="radioinline1">
                      {"Productos"}
                    </Label>
                  </div>
                  <div className="radio radio-primary">
                    <Input
                      id="radioinline2"
                      type="radio"
                      name="radio1"
                      value="option1"
                      onClick={() => filterSegmento("SERVICIOS")}
                    />
                    <Label className="mb-0" for="radioinline2">
                      {"Servicios"}
                    </Label>
                  </div>
                </FormGroup>
              </div>
              <div className={`child-right`}>
                <a
                  className="m-r-15"
                  href="https://b2bsupplies.net/mx/"
                  target="_blank"
                >
                  {"E-Commerce"}
                </a>
              </div>
            </div>

            {serachedItems.length != 0 && products.length == 0 ? (
              <Fragment>
                <hr />
                <div className={`display-flex m-t-15`}>
                  <div>
                    <h4>{"Categorias Disponibles"}</h4>
                    <ScrollArea
                      horizontal={false}
                      vertical={true}
                      style={{ height: "150px" }}
                    >
                      {serachedItems.length == 0 ? (
                        <ul
                          className="p-10"
                          style={{ backgroundColor: "mintcream" }}
                        >
                          {filteredSegmentos.map((segmento, i) => {
                            return (
                              <Fragment>
                                <li
                                  className={`m-b-10 ${
                                    currentSegmento == i ? "f-w-600" : ""
                                  }`}
                                  style={{
                                    textAlign: "initial",
                                    cursor: "pointer",
                                  }}
                                  key={`segmento_${i}_${segmento.code}`}
                                  onClick={() => setSegmento(i, segmento.code)}
                                >
                                  {currentSegmento == i ? (
                                    <i className="fa fa-angle-right"></i>
                                  ) : (
                                    <i className="fa fa-angle-down"></i>
                                  )}{" "}
                                  &nbsp; {segmento.esp}
                                  <hr />
                                </li>
                                {currentSegmento == i ? (
                                  <Fragment>
                                    <ul>
                                      {subFamilias.map((subFamilia, a) => {
                                        return (
                                          <Fragment>
                                            <li
                                              className={`m-l-10 m-b-10 ${
                                                currentFamilia == a
                                                  ? "f-w-600"
                                                  : ""
                                              }`}
                                              style={{
                                                textAlign: "initial",
                                                cursor: "pointer",
                                              }}
                                              key={`subFamilias_${a}_${subFamilia.code}`}
                                              onClick={() => {
                                                selectFamilia(a, subFamilia);
                                              }}
                                            >
                                              {currentFamilia == a ? (
                                                <i className="fa fa-angle-right"></i>
                                              ) : (
                                                <i className="fa fa-angle-down"></i>
                                              )}{" "}
                                              &nbsp;
                                              {subFamilia.esp}
                                              <hr />
                                            </li>
                                            {currentFamilia == a ? (
                                              <Fragment>
                                                <ul>
                                                  {subClases.map(
                                                    (subClas, e) => {
                                                      return (
                                                        <li
                                                          className="m-l-20 m-b-10"
                                                          style={{
                                                            textAlign:
                                                              "initial",
                                                            cursor: "pointer",
                                                          }}
                                                          key={`subClas_${e}`}
                                                          onClick={() => {
                                                            selectClase(
                                                              subClas
                                                            );
                                                          }}
                                                        >
                                                          {"-"}
                                                          &nbsp; {subClas.esp}
                                                          <hr />
                                                        </li>
                                                      );
                                                    }
                                                  )}
                                                </ul>
                                              </Fragment>
                                            ) : (
                                              ""
                                            )}
                                          </Fragment>
                                        );
                                      })}
                                    </ul>
                                  </Fragment>
                                ) : (
                                  ""
                                )}
                              </Fragment>
                            );
                          })}
                        </ul>
                      ) : (
                        <ul
                          className="p-10"
                          style={{ backgroundColor: "mintcream" }}
                        >
                          {serachedItems.map((subClas, e) => {
                            return (
                              <li
                                className="m-l-20 m-b-10"
                                style={{
                                  textAlign: "initial",
                                  cursor: "pointer",
                                }}
                                key={`subClas_${e}`}
                                onClick={() => {
                                  selectClase(subClas);
                                }}
                              >
                                {"-"}
                                &nbsp; {subClas.esp}
                                <hr />
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </ScrollArea>
                  </div>
                  <div className={`child-right`}>
                    <h4>{"Clases Seleccionadas "}</h4>
                    <ul
                      style={{
                        textAlign: "initial",
                        backgroundColor: "mintcream",
                      }}
                      className="p-10"
                    >
                      {selectedClases.map((clase, i) => {
                        return (
                          <li
                            className="m-b-5"
                            style={{ textAlign: "initial", cursor: "pointer" }}
                            key={`selectedClases_${i}_${clase.code}`}
                            onClick={() => deleteClase(clase)}
                          >
                            <Badge color="light">
                              <i className="fa fa fa-close fa-bg"></i> &nbsp;
                              <span className="f-12">{`${clase.esp} ( ${clase.code} )`}</span>
                            </Badge>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <hr />
                {selectedClases.length >= 1 ? (
                  <Button color="primary" onClick={searchForItems}>
                    {"Buscar"}
                  </Button>
                ) : null}
              </Fragment>
            ) : null}
            <hr />
            {products.length > 0 ? ( // || products.length > 0 ?
              <Fragment>
                <Nav className="nav width-100 nav-pills">
                  <NavItem>
                    <NavLink
                      className={`cursor-pointer ${
                        ActiveTab === "1" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("1")}
                    >
                      {"Quiero Cotizar o Comprar"}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={`cursor-pointer ${
                        ActiveTab === "2" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("2")}
                    >
                      {"Quiero encontrar proveedores"}
                    </NavLink>
                  </NavItem>
                </Nav>

                <TabContent activeTab={ActiveTab}>
                  <TabPane className="fade show" tabId="1">
                    {products.length > 0 ? (
                      <Row className="m-t-50">
                        {products.map((prod, i) => {
                          return (
                            <Col sm="4">
                              <Card
                                className="cursor-pointer"
                                onClick={() => {
                                  window.open(prod.product_url, "_blank");
                                }}
                              >
                                <CardBody>
                                  <Media
                                    className="center-horizontal m-b-50"
                                    style={{ width: "200px" }}
                                    src={prod.main_image}
                                  />
                                  <div className={`display-flex`}>
                                    <div className="width-70">
                                      <span className="f-12">
                                        <b>
                                          {prod.name.length < 15
                                            ? prod.name
                                            : `${prod.name.slice(0, 15)}...`}
                                        </b>
                                      </span>
                                    </div>
                                    <div className={`child-right width-30`}>
                                      <b>{`$ ${parseFloat(prod.price).toFixed(
                                        "2"
                                      )}`}</b>
                                    </div>
                                  </div>
                                  <span>
                                    <div dangerouslySetInnerHTML={prod.description}></div>
                                  </span>
                                </CardBody>
                              </Card>
                            </Col>
                          );
                        })}
                      </Row>
                    ) : (
                      <span className="f-18">
                        <b>
                          {
                            "No existe registro de productos bajo el UNSPC solicitado"
                          }
                        </b>
                      </span>
                    )}
                  </TabPane>
                  <TabPane tabId="2">
                    {suppliers.length > 0 ? (
                      <Row className="m-t-50">
                        {suppliers.map((supplier, i) => {
                          return (
                            <Col sm="4">
                              <Card
                                className="cursor-pointer"
                                onClick={() => {
                                  window.open(supplier.supplier_url, "_blank");
                                }}
                              >
                                <CardBody>
                                  <Media
                                    className="center-horizontal m-b-50"
                                    style={{ width: "200px" }}
                                    src={supplier.main_image}
                                  />
                                  <div className={`display-flex`}>
                                    <div className="width-70">
                                      <span className="f-12">
                                        <b>
                                          {supplier.name.length < 15
                                            ? supplier.name
                                            : `${supplier.name.slice(
                                                0,
                                                15
                                              )}...`}
                                        </b>
                                      </span>
                                    </div>
                                    <div className={`child-right width-30`}>
                                      <b>{`${parseFloat(supplier.phone)}`}</b>
                                    </div>
                                  </div>
                                  <div dangerouslySetInnerHTML={supplier.description}></div>
                                </CardBody>
                              </Card>
                            </Col>
                          );
                        })}
                      </Row>
                    ) : (
                      <span className="f-18">
                        <b>
                          {
                            "No existe registro de proveedores con la oferta de productos de el UNSPC solicitado"
                          }
                        </b>
                      </span>
                    )}
                  </TabPane>
                </TabContent>
              </Fragment>
            ) : null}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Buscador;
